export const PROMOTIONS_FALLBACK_URL =
  "https://sportsbook.fanduel.com/promotions";
